const monthNames: string[] = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
];

export const getMonthNameByIndex = (index: number) => monthNames[index - 1];
